// --------------------------------------------------------------------------
// #TBC - Print chart
// --------------------------------------------------------------------------
// Author:      Alex Baulch
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
require('svg-to-canvas');

module.exports = function (options) {
  var context = options.context;

  function init() {
    context.on('click', function (e) {
      e.preventDefault();
      var action = $(this).data('action');

      if (action === 'download') {
        var chart = $('[data-binding="chart-container"]').highcharts();
        var today = new Date();
        var chartName = 'chart-' + today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getUTCFullYear();

        chart.exportChart({
          type: 'application/pdf',
          filename: chartName
        });
      } else if (action === 'print') {
        window.print();
      }
    });
  }

  return {
    init: init
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/charting/charting-print-chart.js
// module id = 245
// module chunks = 0